<template lang="html">
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="1050"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="primary" 
        v-on="on"
      >
        Edit
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :text="`Change User ${`${type}`.toUpperCase()} Roles`"
      :title="`User ${`${type}`.toUpperCase()} Roles`"
      :loading="loading"
      color="hrissecondary"
      class="mb-0"
    >
      <v-form v-if="!loading">
        <v-container>
          <v-row class="overflow">
            <v-col>
              <v-data-iterator
                :items="roles"
                :hide-default-footer="true"
                disable-pagination
                item-key="name"
              >
                <template v-slot:default="roles">
                  <v-row>
                    <v-col
                      v-for="(role,index) in roles.items"
                      :key="index"
                      cols="12"
                      md="6"
                    >
                      <v-card>
                        <v-card-title>
                          <v-btn-toggle v-model="role.selected">
                            <v-btn
                              class="px-0"
                              small
                              active-class="primary lighten-1"
                            >
                              <v-icon :color="role.selected === 0 ? 'white' : 'grey'">
                                mdi-check-circle
                              </v-icon>
                            </v-btn>
                            <v-btn
                              class="px-0"
                              small
                              active-class="primary lighten-1"
                            >
                              <v-icon :color="role.selected === 1 ? 'white' : 'grey'">
                                mdi-clock {{ role.selected == 1? 'mdi-spin':'' }}
                              </v-icon>
                            </v-btn>
                          </v-btn-toggle>

                          <span class="ml-4 caption text-no-wrap text-truncate">{{ role.name }}</span>
                        </v-card-title>

                        <v-divider />

                        <v-list
                          v-if="role.selected"
                          class="py-0"
                        >
                          <v-list-item>
                            <v-list-item-content class="py-0">
                              <v-row>
                                <v-col class="py-0">
                                  <v-menu
                                    v-model="role.startMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="role.tempStartDisplay"
                                        class="mt-4"
                                        label="Start Date"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                      />
                                    </template>
                                    <v-date-picker
                                      v-model="role.tempStart"
                                      no-title
                                      class="datepicker"
                                      @change="role.tempStartDisplay = formatDate(role.tempStart)"
                                      @input="role.startMenu = false"
                                    />
                                  </v-menu>
                                </v-col>

                                <v-col class="py-0">
                                  <v-menu
                                    v-model="role.endMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="role.tempEndDisplay"
                                        class="mt-4"
                                        label="End Date"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                      />
                                    </template>
                                    <v-date-picker
                                      v-model="role.tempEnd"
                                      no-title
                                      class="datepicker"
                                      @change="role.tempEndDisplay = formatDate(role.tempEnd)"
                                      @input="role.endMenu = false"
                                    />
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>            
          </v-row>          
        </v-container>
      </v-form>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"   
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        required: true,
      },
      userUid: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      dialog: null,
      loading: false,
      progressing: false,
      roles: [],
    }),
    watch: {
      dialog: function (dialog) {
        if (dialog) {
          this.loadInitalData()
        }
      },
    },
    methods: {    
      loadInitalData () {
        this.loading = true

        this.$api.hrisRoles().list()
          .then((res) => {
            if (this.type === 'hrm') {
              res.data = res.data.filter(data => {
                return data.id !== 1
              })
            }
            
            this.setBaseRoles(res.data)

            if (this.roles.length > 0) {
              this.resetBaseData()
            }

            this.$http.all([
              this.$api.hrisUserRoles(this.type).list(this.userUid), 
              this.$api.hrisUserTempRoles(this.type).list(this.userUid),
            ])
              .then(this.$http.spread((roles, tempRoles) => {
                this.setUserRoles(roles.data)
                this.setUserTempRoles(tempRoles.data)

                this.loading = false          
              }))
          })
      },
      submitForm () {
        this.setProgressing(true)

        this.$http.all([
          this.$api.hrisUserRoles(this.type).update(this.userUid, this.prepareRoleFormData()), 
          this.$api.hrisUserTempRoles(this.type).update(this.userUid, this.prepareTempRoleFormData()),
        ])
          .then(this.$http.spread((role, tempRole) => {
            if (role.status === 200 && tempRole.status === 200) {            
              this.$emit('updated')    

              this.clearCache()

              this.dialog = false   
            } 
          }))
          .catch(() => {})
          .then(() => {
            this.setProgressing(false)
          })    
      },
      clearCache () {
        this.$http.get('/api/cache/clear')
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      resetBaseData () {
        this.roles.forEach((role) => {
          role.startMenu = false
          role.endMenu = false
          role.selected = null
          role.tempStart = new Date().toISOString().substr(0, 10)
          role.tempEnd = new Date().toISOString().substr(0, 10)
          role.tempStartDisplay = this.formatDate(role.tempStart)
          role.tempEndDisplay = this.formatDate(role.tempEnd)
          role.exists = false
        })
      },
      setBaseRoles (roles) {
        let t = JSON.parse(JSON.stringify(roles))
        t.forEach((role) => {
          role.startMenu = false
          role.endMenu = false
          role.selected = null
          role.tempStart = new Date().toISOString().substr(0, 10)
          role.tempEnd = new Date().toISOString().substr(0, 10)
          role.tempStartDisplay = this.formatDate(role.tempStart)
          role.tempEndDisplay = this.formatDate(role.tempEnd)
          role.exists = false
        })

        this.roles = t
      },
      setUserRoles (roles) {
        let t = JSON.parse(JSON.stringify(roles))

        t.forEach((userRole) => {
          this.roles.forEach((role) => {
            if (role.id === userRole.id) {
              role.selected = 0
              role.exists = true
            }
          })
        })
      },
      setUserTempRoles (tempRoles) {
        let t = JSON.parse(JSON.stringify(tempRoles))

        t.forEach((trole) => {
          this.roles.forEach((role) => {
            if (role.id === trole.id) {
              role.tempStart = this.$moment(trole.pivot.start_date, 'YYYY-MM-DD  HH:mm:ss').format('YYYY-MM-DD')
              role.tempEnd = this.$moment(trole.pivot.end_date, 'YYYY-MM-DD  HH:mm:ss').format('YYYY-MM-DD')
              role.tempStartDisplay = this.formatDate(trole.pivot.start_date)
              role.tempEndDisplay = this.formatDate(trole.pivot.end_date)
              role.selected = 1
            }
          })
        })
      },
      formatDate (date) {
        return this.$moment(date).format('DD/MM/YYYY')
      },
      prepareRoleFormData () {
        let selected = []

        this.roles.forEach((role) => {
          if (role.exists === true && role.selected === 1) {
            selected.push(role.id)
          } else {
            if (role.selected === 0) {
              selected.push(role.id)
            }
          }
        })
        
        return selected
      },
      prepareTempRoleFormData () {   
        let selected = []

        this.roles.forEach((role) => {
          if (role.selected === 1) {
            selected.push({
              id: role.id,
              start_date: this.$moment(role.tempStart, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
              end_date: this.$moment(role.tempEnd, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
            })
          }
        }) 

        return selected
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }

  .overflow {
    overflow-y:scroll; 
    height:60vh;
  }
</style>
